export const gtGreen = "#83bc20"
export const gtBlue = "#0083C6"
export const gtGray = "#63666A"
export const primary1Palette = {
  0: "#A4E504",
  1: "#92CC04",
  2: "#6D9903",
  3: "#496602",
  4: "#243301",
}
export const primary2Pallete = {
  0: "#00689E",
  1: "#004E76",
  2: "#00344F",
  3: "#001A27",
  4: "#000C13",
}
export const primary3Pallete = {
  0: "#f5f5f5",
  1: "#f4f4f4",
  2: "#B8BABB",
  3: "#A1A3A5",
  4: "#898C8F",
  5: "#63666A",
  6: "#CFD8DC",
  7: "#4A90E2",
  8: "#F9F9F9",
  9: "#EFEFEF",
  10: "#B0BEC5",
}

export const chartsPallete = {
  0: "#0082C7",
  1: "#00CCCC",
  2: "#66C2A4",
  3: "#ABDDA4",
  4: "#FEE08B",
  5: "#FEAE61",
  6: "#E6F798",
  7: "#3C89BB",
}
